var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('circle-load-progress',[_c('circle-single',{attrs:{"slot":"right"},slot:"right"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }